import { get, del, post, put } from "@/common/authentication/API";
import store from "@/store/store";

export async function postAdventure() {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  const url =
    "https://crescent-backend-v2.herokuapp.com/adventure/AdventureList";
  return post(url, "", config);
}

export function getAllAdventures() {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  return get(
    "https://crescent-backend-v2.herokuapp.com/adventure/AdventureList",
    config
  );
}

export async function postInvite(user_id: string, adventure_id: number) {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  const url =
    "https://crescent-backend.herokuapp.com/adventure/AdventureInvite/Invite" +
    "?user_id=" +
    "?adventure_id=";
  const data = {
    user_id: user_id,
    adventure_id: adventure_id,
  };
  return await post(url, data, config);
}

export async function postAcceptInvite(
  invite_id: number,
  character_id: string
) {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  const url =
    "https://crescent-backend.herokuapp.com/adventure/AdventureInvite/AcceptInvite" +
    "?invite_id=" +
    "?character_id=";
  const data = {
    invite_id: invite_id,
    character_id: character_id,
  };
  return await post(url, data, config);
}

export async function addCharacterToAdventure(
  adventure_id: number,
  character_id: string
) {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  const url =
    "https://crescent-backend.herokuapp.com/adventure/AdventureInvite/AddCharacter" +
    "?adventure_id=" +
    "?character_id=";
  const data = {
    adventure_id: adventure_id,
    character_id: character_id,
  };
  return await post(url, data, config);
}

export async function removeCharacterFromAdventure(
  adventure_id: number,
  character_id: string
) {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  const url =
    "https://crescent-backend.herokuapp.com/adventure/AdventureInvite/RemoveCharacter";
  const data = {
    id: 0,
    adventure_id: adventure_id,
    character_id: character_id,
  };
  return await post(url, data, config);
}

export async function postDeclineInvite(invite_id: number) {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  const url =
    "https://crescent-backend.herokuapp.com/adventure/AdventureInvite/DeclineInvite" +
    "?invite_id=";
  const data = {
    invite_id: invite_id,
  };
  return await post(url, data, config);
}

export function getUserName(user_name: string) {
  const config = {
    headers: {
      AUTH_TOKEN:
        "WCmxrkzQzEJUM9Dfi5ch0fVK3nVAE0uBiDANFMqRFL4Ym-cN0FvAWqn_94EUXSRDRlygP7C0IjZw0Kl2JzQhEw",
    },
  };
  const url =
    "https://crescent-backend.herokuapp.com/adventure/userid/" + user_name;
  return get(url, config);
}

export function getIdByEmail(email: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const url =
    "https://crescent-backend.herokuapp.com/adventure/email_id/" + email;
  return get(url, config);
}

export function getAllInvites() {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  return get("https://crescent-backend.herokuapp.com/adventure/invite", config);
}

export function removeInvite(invite_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
    data: {
      invite_id: invite_id,
    },
  };
  return del("https://crescent-backend.herokuapp.com/adventure/invite", config);
}

export function addCharAdvPair(character_id: string, adventure_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const url = "https://crescent-backend.herokuapp.com/adventure/pair";
  const data = {
    character_id: character_id,
    adventure_id: adventure_id,
  };
  return post(url, data, config);
}

export function getPairs(adventure_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const url = `https://crescent-backend.herokuapp.com/adventure/pair?adventure_id=${adventure_id}`;
  return get(url, config);
}

export function exitCharacter(character_id: string, adventure_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
    data: {
      character_id: character_id,
      adventure_id: adventure_id,
    },
  };
  const url = "https://crescent-backend.herokuapp.com/adventure/pair";
  return del(url, config);
}

export function deleteAdventure(adventure_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
    data: {
      adventure_id: adventure_id,
    },
  };
  //const url =
  //"https://crescent-backend.herokuapp.com/adventure/deleteAdventure";
  const url = "https://crescent-backend.herokuapp.com/adventure/adventure";
  return del(url, config);
}

export async function buildNpc(
  npcName: string,
  npcDescription: string,
  npcAbilities: string,
  maxHp: string,
  maxMana: string
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  // const url = "https://crescent-backend.herokuapp.com/adventure/makenpc";
  const url = "https://crescent-backend.herokuapp.com/adventure/npc";
  const data = {
    npcName: npcName,
    npcDescription: npcDescription,
    npcAbilities: npcAbilities,
    maxHp: maxHp,
    maxMana: maxMana,
  };
  return post(url, data, config);
}

export async function makeNpcPair(npc_id: string, adventure_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const url = "https://crescent-backend.herokuapp.com/adventure/npcpairs";
  const data = {
    npc_id: npc_id,
    adventure_id: adventure_id,
  };

  return post(url, data, config);
}

export async function postMonster(info: {
  monster_name: string;
  monster_hp: string;
  monster_mp: string;
  monster_mana: string;
  monster_movespeed: string;
  monster_description: string;
  monster_image: string;
}) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const data = {
    monster_name: info.monster_name,
    monster_hp: info.monster_hp,
    monster_mp: info.monster_mp,
    monster_mana: info.monster_mana,
    monster_movespeed: info.monster_movespeed,
    monster_description: info.monster_description,
    monster_image: info.monster_image,
  };
  const url = "https://crescent-backend.herokuapp.com/monster/monster";
  return post(url, data, config);
}

export async function putMonster(info: {
  monster_id: string;
  monster_name: string;
  monster_hp: string;
  monster_mp: string;
  monster_mana: string;
  monster_movespeed: string;
  monster_description: string;
}) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const data = {
    monster_id: info.monster_id,
    monster_name: info.monster_name,
    monster_hp: info.monster_hp,
    monster_mp: info.monster_mp,
    monster_mana: info.monster_mana,
    monster_movespeed: info.monster_movespeed,
    monster_description: info.monster_description,
  };
  const url = "https://crescent-backend.herokuapp.com/monster/monster";
  return put(url, data, config);
}

export async function getMonster(monster_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const url = `https://crescent-backend.herokuapp.com/monster/monster?monster_id=${monster_id}`;
  return get(url, config);
}

export async function monsterPair(monster_id: string, adventure_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const data = {
    monster_id: monster_id,
    adventure_id: adventure_id,
  };
  const url = "https://crescent-backend.herokuapp.com/monster/pair";
  return post(url, data, config);
}

export async function deleteMonsterPair(
  monster_id: string,
  adventure_id: string
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
    data: {
      monster_id: monster_id,
      adventure_id: adventure_id,
    },
  };
  const url = "https://crescent-backend.herokuapp.com/monster/pair";
  return del(url, config);
}

export async function putAttributes(
  monster_id: string,
  info: {
    strength: number;
    agility: number;
    health: number;
    perception: number;
    willpower: number;
    charisma: number;
    intelligence: number;
    power: number;
  }
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const data = {
    monster_id: monster_id,
    strength: info.strength,
    agility: info.agility,
    health: info.health,
    perception: info.perception,
    willpower: info.willpower,
    charisma: info.charisma,
    intelligence: info.intelligence,
    power: info.power,
  };

  const url = `https://crescent-backend.herokuapp.com/monster/attribute`;
  return put(url, data, config);
}

export async function postAttributes(
  monster_id: string,
  info: {
    strength: number;
    agility: number;
    health: number;
    perception: number;
    willpower: number;
    charisma: number;
    intelligence: number;
    power: number;
  }
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const data = {
    monster_id: monster_id,
    strength: info.strength,
    agility: info.agility,
    health: info.health,
    perception: info.perception,
    willpower: info.willpower,
    charisma: info.charisma,
    intelligence: info.intelligence,
    power: info.power,
  };

  const url = `https://crescent-backend.herokuapp.com/monster/attribute`;
  return post(url, data, config);
}

export async function getMonsterAttributes(monster_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const url = `https://crescent-backend.herokuapp.com/monster/attribute?monster_id=${monster_id}`;
  return get(url, config);
}

export async function postMartialPerk(
  rank: string,
  name: string,
  monster_id: string
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const data = {
    monster_id: monster_id,
    rank: rank,
    name: name,
  };

  const url = "https://crescent-backend.herokuapp.com/monster/martialperks";
  return post(url, data, config);
}

export async function getMonsterMartialPerks(monster_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const url = `https://crescent-backend.herokuapp.com/monster/martialperks?monster_id=${monster_id}`;
  return get(url, config);
}

export async function deleteMonsterMartialPerks(
  monster_id: string,
  name: string
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
    data: {
      monster_id: monster_id,
      name: name,
    },
  };

  const url = "https://crescent-backend.herokuapp.com/monster/martialperks";
  return del(url, config);
}

export async function postSpell(
  rank: string,
  name: string,
  monster_id: string
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const data = {
    monster_id: monster_id,
    rank: rank,
    name: name,
  };

  const url = "https://crescent-backend.herokuapp.com/monster/spells";
  return post(url, data, config);
}

export async function getMonsterSpell(monster_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const url = `https://crescent-backend.herokuapp.com/monster/spells?monster_id=${monster_id}`;
  return get(url, config);
}

export async function deleteSpell(monster_id: string, name: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
    data: {
      monster_id: monster_id,
      name: name,
    },
  };

  const url = "https://crescent-backend.herokuapp.com/monster/spells";
  return del(url, config);
}

export async function postWeaponSkills(
  rank: string,
  name: string,
  monster_id: string
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const data = {
    monster_id: monster_id,
    rank: rank,
    name: name,
  };

  const url = "https://crescent-backend.herokuapp.com/monster/weaponskill";
  return post(url, data, config);
}

export async function getMonsterWeaponSkills(monster_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const url = `https://crescent-backend.herokuapp.com/monster/weaponskill?monster_id=${monster_id}`;
  return get(url, config);
}

export async function deleteWeaponSkills(monster_id: string, name: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
    data: {
      monster_id: monster_id,
      name: name,
    },
  };

  const url = "https://crescent-backend.herokuapp.com/monster/weaponskill";
  return del(url, config);
}

export async function postOtherAbilities(
  rank: string,
  name: string,
  monster_id: string
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const data = {
    monster_id: monster_id,
    rank: rank,
    name: name,
  };

  const url = "https://crescent-backend.herokuapp.com/monster/otherability";
  return post(url, data, config);
}

export async function getMonsterOtherAbilities(monster_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const url = `https://crescent-backend.herokuapp.com/monster/otherability?monster_id=${monster_id}`;
  return get(url, config);
}

export async function deleteOtherAbilities(monster_id: string, name: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
    data: {
      monster_id: monster_id,
      name: name,
    },
  };

  const url = "https://crescent-backend.herokuapp.com/monster/otherability";
  return del(url, config);
}

export async function getMonsterPairs(adventure_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const url = `https://crescent-backend.herokuapp.com/monster/pair?adventure_id=${adventure_id}`;

  return get(url, config);
}

export async function getDefenseValues(monster_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const url = `https://crescent-backend.herokuapp.com/monster/defense?monster_id=${monster_id}`;
  return get(url, config);
}

export async function postDefenseValues(
  monster_id: string,
  info: {
    armor: number;
    move: number;
    shield: number;
    bonus: number;
  }
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const data = {
    monster_id: monster_id,
    armor: info.armor,
    move: info.move,
    shield: info.shield,
    bonus: info.bonus,
  };

  const url = "https://crescent-backend.herokuapp.com/monster/defense";
  return post(url, data, config);
}

export async function putDefenseValues(
  monster_id: string,
  info: {
    armor: number;
    move: number;
    shield: number;
    bonus: number;
  }
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const data = {
    monster_id: monster_id,
    armor: info.armor,
    move: info.move,
    shield: info.shield,
    bonus: info.bonus,
  };

  const url = "https://crescent-backend.herokuapp.com/monster/defense";
  return put(url, data, config);
}

export async function postJournalEntry(
  adventure_id: string,
  title: string,
  body: string
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };
  const data = {
    adventure_id: adventure_id,
    title: title,
    body: body,
  };

  const url = "https://crescent-backend.herokuapp.com/adventure/journal";
  return post(url, data, config);
}

export async function getJournalEntry(adventure_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const url = `https://crescent-backend.herokuapp.com/adventure/journal?adventure_id=${adventure_id}`;
  return get(url, config);
}

export async function postAdventureColor(
  adventure_id: string,
  info: {
    pageBackground: string;
    textShade1: string;
    textShade2: string;
    componentBacking: string;
    inputBacking: string;
    alertShade: string;
    font: string;
  }
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const data = {
    adventure_id: adventure_id,
    pageBackground: info.pageBackground,
    textShade1: info.textShade1,
    textShade2: info.textShade2,
    componentBacking: info.componentBacking,
    inputBacking: info.inputBacking,
    alertShade: info.alertShade,
    font: info.font,
  };

  const url = "https://crescent-backend.herokuapp.com/adventure/adv_color";
  return post(url, data, config);
}

export async function putAdventureColor(
  adventure_id: string,
  info: {
    pageBackground: string;
    textShade1: string;
    textShade2: string;
    componentBacking: string;
    inputBacking: string;
    alertShade: string;
    font: string;
  }
) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const data = {
    adventure_id: adventure_id,
    pageBackground: info.pageBackground,
    textShade1: info.textShade1,
    textShade2: info.textShade2,
    componentBacking: info.componentBacking,
    inputBacking: info.inputBacking,
    alertShade: info.alertShade,
    font: info.font,
  };

  const url = "https://crescent-backend.herokuapp.com/adventure/adv_color";
  return put(url, data, config);
}

export async function getAdventureColor(adventure_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const url = `https://crescent-backend.herokuapp.com/adventure/adv_color?adventure_id=${adventure_id}`;

  return get(url, config);
}

export async function postCharacterColor(info: {
  character_id: string;
  adventure_id: string;
  characterBacking: string;
  characterTextShade1: string;
  characterInputBacking: string;
  characterTextShade2: string;
}) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const data = {
    character_id: info.character_id,
    adventure_id: info.adventure_id,
    characterBacking: info.characterBacking,
    characterTextShade1: info.characterTextShade1,
    characterInputBacking: info.characterInputBacking,
    characterTextShade2: info.characterTextShade2,
  };

  const url = "https://crescent-backend.herokuapp.com/adventure/char_color";
  return post(url, data, config);
}

export async function putCharacterColor(info: {
  character_id: string;
  characterBacking: string;
  characterTextShade1: string;
  characterInputBacking: string;
  characterTextShade2: string;
}) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const data = {
    character_id: info.character_id,
    characterBacking: info.characterBacking,
    characterTextShade1: info.characterTextShade1,
    characterInputBacking: info.characterInputBacking,
    characterTextShade2: info.characterTextShade2,
  };

  const url = "https://crescent-backend.herokuapp.com/adventure/char_color";
  return put(url, data, config);
}

export async function getCharacterColor(adventure_id: string) {
  const config = {
    headers: {
      AUTH_TOKEN: store.getters["authToken"],
    },
  };

  const url = `https://crescent-backend.herokuapp.com/adventure/char_color?adventure_id=${adventure_id}`;
  return get(url, config);
}
